const storageKey = 'storage-tracker';
const storage = window.localStorage;
const set = value => storage.setItem(storageKey, value);
const remove = () => storage.removeItem(storageKey);
const get = () => storage.getItem(storageKey);

export const storageTracker = {
  set,
  remove,
  get,
};
